// extracted by mini-css-extract-plugin
export default {"contents-container":"St0EYdcs5heVpLk14icE","table-container":"P_wRHi61oBm_szC09psQ"};